interface InputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
}

export const Input = ({ value, onChange, placeholder }: InputProps) => {
    return (
        <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
    );
};